import { __assign } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { ViewerContext } from "../lib/ViewerContext";
import { viewerData as defaultViewerData } from "../constants";
export var ViewerProvider = function (_a) {
    var siteId = _a.siteId, children = _a.children;
    var _b = useState(__assign(__assign({}, defaultViewerData), { siteId: siteId })), viewerData = _b[0], setViewerData = _b[1];
    useEffect(function () {
        setViewerData(function (prev) { return (__assign(__assign({}, prev), { siteId: siteId })); });
    }, [siteId]);
    var contextValue = useMemo(function () { return (__assign(__assign({}, viewerData), { setViewerData: setViewerData })); }, [viewerData]);
    return (_jsx(ViewerContext.Provider, __assign({ value: contextValue }, { children: children })));
};
